import common from './views/en/common'
import login from './views/en/login'
import register from './views/en/register'
import password_restore from './views/en/password_restore'
import verify_account from './views/en/verify_account'
import terrains from './views/en/terrains'
import plots from './views/en/plots'
import dashboard_layout from './views/en/dashboardLayout'
import dashboard from './views/en/dashboard'
import account from './views/en/account'
import modules from './views/en/modules'
import terrain_manager from './views/en/terrain_manager'
import plot_manager from './views/en/plot_manager'
import sensors from './views/en/sensors'
import graphics from './views/en/graphics'

const en = {
    authNavBar: common.authNavBar,
    login: login,
    register: register,
    verify_account: verify_account,
    password_restore: password_restore,
    common: common,
    dashboard_layout: dashboard_layout,
    terrains: terrains,
    plots: plots,
    modules: modules,
    dashboard: dashboard,
    account: account,
    terrain_manager: terrain_manager,
    plot_manager: plot_manager,
    sensors: sensors,
    graphics: graphics,
}

export default en;